const swDev = () => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        const serviceWorkerFile = process.env.NODE_ENV === 'production' 
          ? `${process.env.PUBLIC_URL}/sw.Production.js` 
          : `${process.env.PUBLIC_URL}/sw.js`;
        
        navigator.serviceWorker
          .register(serviceWorkerFile)
          .then((registration) => {
            console.log('✅ Service Worker registered:', registration.scope);
          })
          .catch((error) => {
            console.error('❌ Service Worker registration failed:', error);
          });
      });
    }
  };
  
  export default swDev;
  